import React from 'react';
import Component from './Component';
import Header from './Header';


class Container extends Component {
  componentDidMount = () => {
    // Must agree with the title the server puts in the head -- see page-meta.json. A page can
    // name itself outright, which is what a blog post does; the rest are the site plus a section.
    const { page, title } = this.props;
    document.title = title || (page && page !== 'Home' ? 'Cerebral Cereal | ' + page : 'Cerebral Cereal');
  }

  render = () => {
    const { page, children, className, showHeader=true } = this.props;
    let classes = "container ";
    if (className) classes += className;
    
    return (
      <>
        {
        showHeader && (
          <>
            <Header page={page} />
            <div className="header-pad" />
          </>
        )}
        <div className={classes}>{children}</div>
      </>
    );
  }
}

export default Container;